import { render, staticRenderFns } from "./TargetingAddButton.vue?vue&type=template&id=2de4e866&scoped=true&"
import script from "./TargetingAddButton.vue?vue&type=script&lang=js&"
export * from "./TargetingAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de4e866",
  null
  
)

export default component.exports